// Computes the same occurrence dates as the backend, for the create-series preview.
// pattern: "weekly" | "monthly_weekday"
// interval: weekly gap (1 = weekly, 2 = biweekly)
// count: total occurrences INCLUDING the first
export function computeRecurrenceDates(base, pattern, interval, count) {
  if (!base || count < 1) return [];
  const dates = [new Date(base)];
  if (pattern === "weekly") {
    for (let i = 1; i < count; i++) {
      const d = new Date(base);
      d.setDate(d.getDate() + 7 * interval * i);
      dates.push(d);
    }
  } else if (pattern === "monthly_weekday") {
    const weekday = base.getDay(); // 0 Sun .. 6 Sat
    const nth = Math.floor((base.getDate() - 1) / 7) + 1;
    for (let i = 1; i < count; i++) {
      const year = base.getFullYear() + Math.floor((base.getMonth() + i) / 12);
      const month = (base.getMonth() + i) % 12;
      const first = new Date(year, month, 1, base.getHours(), base.getMinutes());
      let offset = (weekday - first.getDay() + 7) % 7;
      let day = 1 + offset + 7 * (nth - 1);
      const lastDay = new Date(year, month + 1, 0).getDate();
      while (day > lastDay) day -= 7;
      dates.push(new Date(year, month, day, base.getHours(), base.getMinutes()));
    }
  }
  return dates;
}
